<style lang="less" scoped>
  .category-content {
    padding: 0 10px;
  }
  .d-f {
    display: flex;
  }
  .f-1 {
    flex:1
  }
</style>
<template>
  <div class="all">
    <div class="d-f">
      <div class="f-1">
        报销金额:
        ￥{{ $util.formatPrice(reimbursement.bx_amount) }}
      </div>
      <div class="f-1">
        报销类型:
        {{ reimbursement.bx_type }}
      </div>
      <div class="f-1">
        报销地点:
        {{ office_name }}
      </div>
    </div>
    <div class="d-f">
      <div class="f-1">
        发票金额:
        ￥{{ $util.formatPrice(reimbursement.invoice_amount) }}
      </div>
      <div class="f-1">
        发票数量:
        {{ $util.formatNumber(reimbursement.invoice_count) }}
      </div>
    </div>
    <div
      v-if="reimbursement.remark"
      class="d-f"
    >
      <div class="f-1">
        报销备注:
        {{ reimbursement.remark || '-' }}
      </div>
    </div>
    <div
      v-if="reimbursement.advance_remark"
      class="d-f"
    >
      <div class="f-1">
        冲预支备注:
        {{ reimbursement.advance_remark || '-' }}
      </div>
    </div>
    <div
      v-for="(detail, index) in category_detail_list"
      :key="`${index}_${$util.guid()}`"
    >
      <p class="text-bold">
        {{ index+1 }}. {{ categoryName(detail.category_id) }}
      </p>
      <div class="category-content">
        <div class="d-f">
          <div class="f-1">
            类别金额:
            ￥{{ $util.formatPrice(detail.amount) }}
          </div>
          <div class="f-1">
            纸票数量:
            {{ $util.formatNumber(detail.paper_invoice_count) }}
          </div>
          <div class="f-1">
            电子发票数量:
            {{ $util.formatNumber(detail.electronic_invoice_count) }}
          </div>
          <div class="f-1">
            替票数量:
            {{ $util.formatNumber(detail.sub_invoice_count) }}
          </div>
          <div class="f-1">
            替票金额:
            ￥{{ $util.formatPrice(detail.sub_invoice_amount) }}
          </div>
        </div>
        <div
          v-if="detail.rough_invoices.length"
          class="invoice-contain"
        >
          <RoughInvoice
            v-for="rough_invoice in detail.rough_invoices"
            :key="rough_invoice.id"
            :invoice="rough_invoice"
            @preview="preview"
          />
        </div>
        <div
          v-else
          class="color-grey"
        >
          无上传发票
        </div>
      </div>
    </div>
    <div class="line">
      <v-btn
        text
        small
        color="primary"
        @click="selectedAll(true)"
      >
        全选
      </v-btn>
      <v-btn
        text
        small
        color="primary"
        @click="selectedAll(false)"
      >
        取消全选
      </v-btn>
      <v-btn
        text
        small
        color="primary"
        :disabled="download_loading || !checked_rough_invoices.length"
        :loading="download_loading"
        @click="batchDownload"
      >
        批量下载
      </v-btn>
      <v-btn
        text
        small
        color="primary"
        :disabled="combine_loading || !checked_rough_invoices.length"
        :loading="combine_loading"
        @click="combinePdf"
      >
        合成一张pdf
      </v-btn>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import {BX_CATEGORY_HASH} from "../fields";
  import VRippleCol from '../../../vuetify_custom/v-ripple-col';
  import RoughInvoice from './rough_invoice';
  export default {
    components: { RoughInvoice, VRippleCol },
    props: {
      reimbursement: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        download_loading: false,
        combine_loading: false,
        category_detail_list: []
      }
    },
    computed: {
      ...mapGetters({
        offices_hash: 'async/offices_hash',
      }),
      office_name() {
        if (this.reimbursement) {
          const office = this.offices_hash[this.reimbursement.office_id];
          return office ? office.name : '-';
        }
        return '-';
      },
      checked_rough_invoices() {
        const arr = [];
        this.category_detail_list.forEach(detail => {
          detail.rough_invoices.forEach(rough_invoice => {
            if (rough_invoice._checkout) {
              arr.push(rough_invoice);
            }
          })
        })
        return arr;
      }
    },
    watch: {
      reimbursement: {
        handler() {
          this.genList();
        },
        deep: true
      },
    },
    created() {
      this.genList();
    },
    mounted() {
      //
    },
    methods: {
      genList() {
        const list = [];
        if (this.reimbursement) {
          const { category_detail_list = [] } = this.reimbursement;
          category_detail_list.forEach((detail) => {
            const item = this.$util.clone(detail);
            item.rough_invoices.forEach((rough_invoice) => {
              rough_invoice._checkout = false;
              if (rough_invoice.ocr_status === 'success') {
                const ocr_res = JSON.parse(rough_invoice.ocr_result);
                rough_invoice.ocr_invoice_list = ocr_res['response']['data']['identify_results'].map(_ => _.details);
              }
            });
            list.push(item);
          });
        }
        this.category_detail_list = list;
      },
      categoryName(category_id) {
        return BX_CATEGORY_HASH[category_id];
      },
      preview(invoice = {}) {
        const filepath = invoice.oss_img_path ? invoice.oss_img_path : invoice.oss_pdf_path;
        if (!filepath) {
          this.$Message.error('未找到文件路径，无法预览');
          return;
        }
        const oss_url = this.$util.publicOSSUrl(filepath);
        window.open(oss_url);
      },
      // 打包下载zip包
      async batchDownload() {
        this.download_loading = true;
        const { zipfile } = await this.$http.post('expense_group/zip_rough_invoices', {
          reimbursement_id: this.reimbursement.id,
          rough_invoice_ids: this.checked_rough_invoices.map(ri => ri.id)
        }).finally(() => { this.download_loading = false })
        const download_url = this.$util.staticFile(zipfile);
        window.open(download_url);
      },
      // 合成一张pdf
      async combinePdf() {
        this.combine_loading = true;
        const { pdf } = await this.$http.post('expense_group/combine_pdf', {
          reimbursement_id: this.reimbursement.id,
          rough_invoice_ids: this.checked_rough_invoices.map(ri => ri.id)
        }).finally(() => { this.combine_loading = false })
        const download_url = this.$util.staticFile(pdf);
        window.open(download_url);
      },
      selectedAll(type) {
        this.category_detail_list.forEach(detail => {
          detail.rough_invoices.forEach(rough_invoice => {
            rough_invoice._checkout = type;
          });
        });
      },
    }
  }
</script>
